import { ComponentProps, FC, useContext } from 'react';
import { useTranslation } from 'utils/i18n';

import { AuthContext } from '../../state/auth';

import Price from '../price';

interface Props extends ComponentProps<typeof Price> {
  price: number;
}

const SpacePrice: FC<Props> = ({
  helpText,
  labelPosition = 'bottom',
  labelText,
  showPrice,
  ...props
}) => {
  const { t } = useTranslation('common');
  const { loggedIn, accountApproved } = useContext(AuthContext);

  const renderPriceHelpText = () => {
    if (loggedIn && !accountApproved) {
      return t('space_list_item.sign_in_warning.unapproved_user');
    }

    if (!loggedIn) {
      return t('space_list_item.sign_in_warning.signed_out');
    }

    return undefined;
  };

  return (
    <Price
      {...props}
      labelText={labelText || t('space_list_item.price.price_per_hour')}
      labelPosition={labelPosition}
      showPrice={
        showPrice === undefined ? loggedIn && accountApproved : showPrice
      }
      helpText={helpText === undefined ? renderPriceHelpText() : helpText}
    />
  );
};

export default SpacePrice;
